import callApi, { CallApiResult, getCustomerId } from 'src/api';
import CustomerMailAddress from 'src/entities/customer/CustomerMailAddress';
import {
    SCHEMA_CUSTOMER_MAIL_ADDRESS_SHAPE,
    SCHEMA_CUSTOMER_PHONE_NUMBER_SHAPE,
    SCHEMA_MY_DATA_SHAPE,
    SCHEMA_PASSWORD_RESET_SHAPE,
} from 'src/schemas/MyData';

/* Customer Mail Addresses */

export const fetchCustomerMailAddresses = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/customer/' + customerId + '/mailAddress';
    return callApi(endpoint);
};

export const fetchCustomerMailAddressById = (mailAddressId: string): Promise<CallApiResult<CustomerMailAddress>> => {
    const endpoint = `/api/customer/mailAddress/${mailAddressId}`;
    return callApi(endpoint);
};

export const submitCustomerMailAddress = (data: SCHEMA_CUSTOMER_MAIL_ADDRESS_SHAPE): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/' + customerId + '/mailAddress', { method: 'POST', data });
};

export const assignCustomerMailAddress = (
    type: 'account' | 'newsletter',
    id: string = 'null'
): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi(`/api/customer/${customerId}/mailAddress/${type}/${id}`, { method: 'POST' });
};

export const deleteCustomerMailAddress = (id: string): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi(`/api/customer/${customerId}/mailAddress/${id}`, { method: 'DELETE' });
};

/* Customer Phone Numbers */

export const fetchCustomerPhoneNumbers = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/customer/' + customerId + '/phoneNumber';
    return callApi(endpoint);
};

export const submitCustomerPhoneNumber = (data: SCHEMA_CUSTOMER_PHONE_NUMBER_SHAPE): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/' + customerId + '/phoneNumber', { method: 'POST', data });
};

export const assignCustomerPhoneNumber = (id: string = 'null'): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi(`/api/customer/${customerId}/phoneNumber/account/${id}`, { method: 'POST' });
};

export const deleteCustomerPhoneNumber = (id: string): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi(`/api/customer/${customerId}/phoneNumber/${id}`, { method: 'DELETE' });
};

/* Customer Data */

export const fetchCustomerData = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();

    const endpoint = '/api/customer/' + customerId + '/myData';
    return callApi(endpoint);
};

export const submitMyDataForm = (raw: SCHEMA_MY_DATA_SHAPE): Promise<CallApiResult> => {
    const data = {
        ...raw,
    };
    const customerId = getCustomerId();
    return callApi('/api/customer/' + customerId + '/myData', { method: 'PATCH', data });
};

/* Resend Confirmation Email */
export const resendConfirmationEmail = (emailAddressId: string): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/mailAddress/${emailAddressId}/resendConfirmationToken`;
    return callApi(endpoint, { method: 'POST' });
};

export const submitPasswordResetForm = (data: SCHEMA_PASSWORD_RESET_SHAPE): Promise<CallApiResult> => {
    return callApi('/api/customer/current/resetPassword', { method: 'PUT', data });
};
